import type { RouteRecordRaw, Router } from 'vue-router'

const HelpRecipientRoutes: RouteRecordRaw = {
  path: '/HelpRecipient',
  name: 'HelpRecipientModulePages',
  redirect: { name: 'HelpRecipientMainPages' },
  children: [
    {
      path: '',
      name: 'HelpRecipientMainPages',
      component: () => import('./views/ManageHelpRecipientView.vue'),
      meta: {
        title: 'helpRecipient.helpRecipients',
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(HelpRecipientRoutes)
}
